import { ILocationAllPlatformsConfig, ILocationPlatformConfig, TLocationPlatform } from "../location.t";
import { LOCATION_CONFIGS, LOCATION_PLATFORM } from "../locationConstants";
import appHistory from "../../../app/appHistory";
import checkIsLocationPathnameMatch from "./checkIsLocationPathnameMatch";
import checkIsLocationSearchMatch from "./checkIsLocationSearchMatch";
import mergeLocationSearchStrings from "./mergeLocationSearchStrings";
import excludeLocationSearchStrings from "./excludeLocationSearchStrings";

interface IFormRedirectUrlParams {
    compareLocationConfig?: ILocationPlatformConfig;
    currentLocationConfig?: ILocationPlatformConfig;
    currentSearch: string;
}

function formRedirectUrl({ currentLocationConfig, compareLocationConfig, currentSearch }: IFormRedirectUrlParams) {
    const redirectPathname = currentLocationConfig?.pathname || '/';
    let redirectSearch = excludeLocationSearchStrings(currentSearch, compareLocationConfig?.search);
    redirectSearch = mergeLocationSearchStrings(currentLocationConfig?.search || '', redirectSearch);

    return `${redirectPathname}?${redirectSearch}`;
}

export function getCurrentPlatformRedirectPath(currentPlatform: TLocationPlatform, pathName?: string, search?: string) {
    const comparePlatform: TLocationPlatform = currentPlatform === LOCATION_PLATFORM.DESKTOP
        ? LOCATION_PLATFORM.MOBILE
        : LOCATION_PLATFORM.DESKTOP;

    const locationConfigsWithDiffPlatforms = Object
        .values(LOCATION_CONFIGS)
        .filter((config: ILocationAllPlatformsConfig) => config.desktop || config.mobile) as ILocationAllPlatformsConfig[];

    let redirectUrl = '';
    const currentPath = pathName || appHistory.location.pathname.replace(/\/$/, '') || '/';
    const currentSearch = search || appHistory.location.search;

    // Check if current location matches with compare location with pathname and search
    for (let i = 0; i < locationConfigsWithDiffPlatforms.length; i++) {
        const locationConfig = locationConfigsWithDiffPlatforms[i];
        const currentLocationConfig = locationConfig[currentPlatform];
        const compareLocationConfig = locationConfig[comparePlatform];

        if (
            compareLocationConfig &&
            checkIsLocationPathnameMatch(currentPath, compareLocationConfig.pathname, compareLocationConfig.exact) &&
            checkIsLocationSearchMatch(currentSearch, compareLocationConfig.search)
        ) {
            redirectUrl = formRedirectUrl({ currentLocationConfig, compareLocationConfig, currentSearch });
            break;
        }
    }

    // If full match not found check at least pathname match
    if (redirectUrl === '') {
        for (let i = 0; i < locationConfigsWithDiffPlatforms.length; i++) {
            const locationConfig = locationConfigsWithDiffPlatforms[i];
            const currentLocationConfig = locationConfig[currentPlatform];
            const compareLocationConfig = locationConfig[comparePlatform];

            if (
                currentPath !== '/' &&
                compareLocationConfig?.pathname && compareLocationConfig?.pathname !== '/' &&
                checkIsLocationPathnameMatch(currentPath, compareLocationConfig.pathname)
            ) {
                redirectUrl = formRedirectUrl({ currentLocationConfig, compareLocationConfig, currentSearch });
                break;
            }
        }
    }

    return redirectUrl;
}